class VtAutocheck extends HTMLElement {
  connectedCallback() {
    if (this._klaar) return;
    this._klaar = true;
    const d = this.dataset;
    this.verbruik = parseFloat(String(d.verbruik || '').replace(',', '.'));
    this.dagrit = parseFloat(d.dagrit) || 0;
    this.label = this.querySelector('[data-ac-label]');
    this.kw = this.querySelector('[data-ac-kw]');
    this.km = this.querySelector('[data-ac-km]');
    this.dag = this.querySelector('[data-ac-dag]');
    this.noot = this.querySelector('[data-ac-noot]');
    this.basis = {
      label: this.label.textContent, kw: this.kw.textContent,
      km: this.km.textContent, dag: this.dag.textContent
    };
    this.addEventListener('vt-fit:uitslag', (e) => this.toon(e.detail));
  }

  getal(n) {
    const r = Math.round(n * 10) / 10;
    return String(r).replace('.', this.dataset.decimaal || ',');
  }

  duur(uren) {
    const d = this.dataset;
    const min = Math.max(5, Math.round((uren * 60) / 5) * 5);
    if (min < 60) return d.kortMin.replace('[n]', min);
    const u = Math.floor(min / 60);
    const m = min - u * 60;
    if (!m) return d.kortUur.replace('[u]', u);
    return d.kortUurMin.replace('[u]', u).replace('[m]', m);
  }

  toon(uit) {
    const b = this.basis;
    if (!uit || !this.verbruik) {
      this.label.textContent = b.label;
      this.kw.textContent = b.kw;
      this.km.textContent = b.km;
      this.dag.textContent = b.dag;
      if (this.noot) this.noot.hidden = false;
      this.removeAttribute('data-auto');
      return;
    }
    const kw = uit.levert;
    this.label.textContent = (this.dataset.metAuto || '').replace('[naam]', uit.naam);
    this.kw.textContent = this.getal(kw) + ' kW';
    this.km.textContent = '± ' + Math.round((kw / this.verbruik) * 100) + ' km';
    this.dag.textContent = '± ' + this.duur((this.dagrit * this.verbruik) / 100 / kw);
    if (this.noot) this.noot.hidden = true;
    this.setAttribute('data-auto', '');
  }
}
customElements.define('vt-autocheck', VtAutocheck);
